import { render, staticRenderFns } from "./DhlProductCheck.vue?vue&type=template&id=20b31421&lang=true&"
import script from "./DhlProductCheck.vue?vue&type=script&lang=js&"
export * from "./DhlProductCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports